//https://api.sleektradingltd.com
//https://portal-laravel.sleektradingltd.com/api/
import axios from 'axios';
const sleektrading = axios.create({
    baseURL: "https://portal-laravel.sleektradingltd.com/api/",
});

sleektrading.interceptors.request.use(config => {
    const token = sessionStorage.getItem('token');
    config.headers.Authorization =  `Bearer ${token}`;
    return config;
});

export default sleektrading;